module.exports = __webpack_public_path__ + "static/media/endorsement-done.5dc09d66.svg";